// Create Store artwork-axis choice. Product template (general / nike-only)
// is the catalog filter; sport artwork is derived from the sport unless the
// rep pins a specific sport-* doc or opts out to logo-only.

import { sportToArtworkTemplateId } from './store-template-kinds';

export type ArtworkMode = 'auto' | 'logo-only' | 'pick';

export type CreateStoreArtwork = {
  useDesignTemplates: boolean;
  artworkTemplateId?: string;
};

export function resolveCreateStoreArtwork(input: {
  mode: ArtworkMode;
  sport: string;
  pickedArtworkId?: string;
}): CreateStoreArtwork {
  if (input.mode === 'logo-only') {
    return { useDesignTemplates: false };
  }
  if (input.mode === 'pick') {
    const id = String(input.pickedArtworkId || '').trim();
    if (!id) return { useDesignTemplates: true };
    return { useDesignTemplates: true, artworkTemplateId: id };
  }
  const derived = sportToArtworkTemplateId(input.sport);
  if (!derived) return { useDesignTemplates: true };
  return { useDesignTemplates: true, artworkTemplateId: derived };
}
